import { render, staticRenderFns } from "./setServerConfig.vue?vue&type=template&id=f4c5d642&scoped=true&"
import script from "./setServerConfig.vue?vue&type=script&lang=js&"
export * from "./setServerConfig.vue?vue&type=script&lang=js&"
import style0 from "./setServerConfig.vue?vue&type=style&index=0&id=f4c5d642&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c5d642",
  null
  
)

export default component.exports